<p class="error" *ngIf="!isValid" >
  You have forget to add the SalesIq domain or widget code in the component. Kindly check it.
</p>
